import React, { useRef, useEffect, useCallback } from "react";
import EmailEditor from "react-email-editor";
var Builder = function (_a) {
    var onDesignExport = _a.onDesignExport, designHtml = _a.designHtml, designJson = _a.designJson;
    var emailEditorRef = useRef(null);
    useEffect(function () {
        if (designHtml && emailEditorRef.current && emailEditorRef.current.editor) {
            try {
                emailEditorRef.current.editor.loadDesign(designJson);
            }
            catch (error) {
                console.error("Failed to load designHtml:", error);
                // Optionally handle error state or display a message
            }
        }
    }, [designJson]);
    var exportHtml = useCallback(function () {
        if (emailEditorRef.current && emailEditorRef.current.editor) {
            emailEditorRef.current.editor.exportHtml(function (exportedData) {
                var json = exportedData.design; // design json
                var html = exportedData.html; // design html
                onDesignExport(html, json);
            });
        }
    }, [onDesignExport]);
    useEffect(function () {
        var intervalId = setInterval(exportHtml, 1000); // Export HTML every 5 seconds
        return function () { return clearInterval(intervalId); }; // Clean up interval on component unmount
    }, [exportHtml]);
    var onLoad = function () {
        if (designJson && emailEditorRef.current && emailEditorRef.current.editor) {
            try {
                emailEditorRef.current.editor.loadDesign(designJson); // Load the stored design JSON
            }
            catch (error) {
                console.error("Failed to load designJson during onLoad:", error);
                // Optionally handle error state or display a message
            }
        }
    };
    var onReady = function () {
        console.log("Email Editor Ready");
    };
    return (React.createElement("div", null,
        React.createElement(EmailEditor, { ref: emailEditorRef, onLoad: onLoad, onReady: onReady, options: { displayMode: "email" } })));
};
export default Builder;



//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Builder/Builder.tsx
// module id = 64
// module chunks = 0